import React from "react";
import { Pannellum, PannellumVideo } from "pannellum-react";
const Image360 = ({ image }) => {

  return (
      <Pannellum
      image={image}
      autoLoad
      pitch={10}
      yaw={180}
      hfov={500}
      author=''
      title=''
      orientationOnByDefault={false}
      draggable
      keyboardZoom
      mouseZoom
      preview=''
      previewAuthor=''
      previewTitle=''
      showControls
      showFullscreenCtrl
      showZoomCtrl
      hotspotDebug={false}
      />
  );
};

export default Image360;
